import { FieldErrors, UseFormReturn } from 'react-hook-form';
import { Subject } from 'rxjs';

export type FormCoordinatorEvent =
  | { type: 'valid'; id: string }
  | { type: 'invalid'; id: string; errors: FieldErrors<any> | null };

export interface FormHandlerRef {
  id: string;
  ref: React.MutableRefObject<UseFormReturn>;
}

export interface FormHandlerState {
  id: string;
  isDirty?: boolean;
  isValid?: boolean;
  dirtyFields?: Record<string, boolean>;
}

export type FormCoordinatorSubject = Subject<FormCoordinatorEvent>;

/**
 * Crea il Subject (RxJS) che viene utilizzato per registrare i diversi
 * `FormHandler` e per comunicare gli eventi di validazione.
 *
 * Essendo un Subject, è possibile sottoscriversi ad esso per ricevere gli
 * eventi (vedi hook dedicati), senza dover gestire re-render
 * dovuti al cambiamento delle Props.
 */
export function createFormCoordinatorSubject(): FormCoordinatorSubject {
  return new Subject<FormCoordinatorEvent>();
}
